import React, { useState, useEffect } from "react";
import axios from "axios";

export const OpenDeposit = () => {
  const [details, setDetails] = useState({
    scheme: "RDP",
    name: "",
    amount: "",
    tenure: "",
    maturityDate: "",
    account: "",
    openDate: "",
  });
  const [savingsAccounts, setSavingsAccounts] = useState([]);
  const [balanceAvailable, setBalanceAvailable] = useState(true);
  const [status, setStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    getAccounts();
  }, []);

  const getAccounts = async () => {
    const res = await axios.get("http://localhost:5001/chooseaccount");
    setSavingsAccounts(res.data);
  };

  const setDate = () => {
    let date = new Date().toISOString().slice(0, 10);
    setDetails((prevState) => ({
      ...prevState,
      openDate: date,
    }));
  };

  const submitForm = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      await axios.post("http://localhost:5001/opendeposit", {
        data: details,
      });
      setStatus("✅ Your deposit request has been submitted successfully!");
      setDetails({
        scheme: "RDP",
        name: "",
        amount: "",
        tenure: "",
        maturityDate: "",
        account: "",
        openDate: "",
      });
    } catch (err) {
      setStatus("❌ Error submitting deposit request. Please try again.");
      console.log(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const checkAccountBalance = () => {
    let n = 0;
    savingsAccounts.forEach((acc) => {
      if (acc.balance > parseFloat(details.amount) + 1000) {
        n += 1;
      }
    });
    n ? setBalanceAvailable(true) : setBalanceAvailable(false);
  };

  return (
    <div className="open-deposit-container">
      <div className="open-deposit-card">
        <h2>Open New Deposit</h2>
        <p className="deposit-subtitle">Create a fixed deposit to earn higher interest rates</p>
        
        {status && (
          <div className={`status-message ${status.includes('✅') ? 'success' : 'error'}`}>
            {status}
          </div>
        )}

        <form className="deposit-form" onSubmit={submitForm}>
          <div className="form-group">
            <label htmlFor="name">Full Name</label>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Enter your full name"
              onChange={(e) => {
                setDetails((prevState) => ({
                  ...prevState,
                  name: e.target.value,
                }));
              }}
              value={details.name}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="amount">Deposit Amount (₹)</label>
            <input
              type="number"
              name="amount"
              id="amount"
              placeholder="Enter amount"
              onChange={(e) => {
                setDetails((prevState) => ({
                  ...prevState,
                  amount: e.target.value,
                }));
              }}
              onBlur={checkAccountBalance}
              value={details.amount}
              required
              min="1000"
            />
          </div>

          <div className="form-group">
            <label htmlFor="scheme">Deposit Scheme</label>
            <select
              name="scheme"
              id="scheme"
              onChange={(e) => {
                setDetails((prevState) => ({
                  ...prevState,
                  scheme: e.target.value,
                }));
              }}
              value={details.scheme}
              required
            >
              <option value="">Select Scheme</option>
              <option value="RDP">RDP - Regular Deposit Plan (5.25%)</option>
              <option value="SDR">SDR - Special Deposit Rate (5.4%)</option>
              <option value="RDTAX">RDTAX - Tax Saving Deposit</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="tenure">Tenure (months)</label>
            <input
              type="number"
              placeholder="Enter tenure in months"
              onChange={(e) => {
                setDetails((prevState) => ({
                  ...prevState,
                  tenure: e.target.value,
                }));
              }}
              value={details.tenure}
              onBlur={() => {
                setDate();
                if (details.tenure > 0) {
                  let date = new Date();
                  var newDate = new Date(
                    date.setMonth(date.getMonth() + parseInt(details.tenure))
                  )
                    .toISOString()
                    .slice(0, 10);
                  setDetails((prevState) => ({
                    ...prevState,
                    maturityDate: newDate,
                  }));
                }
              }}
              required
              min="1"
              max="120"
            />
          </div>

          <div className="form-group">
            <label htmlFor="account">Source Account</label>
            <select
              name="account"
              id="account"
              onChange={(e) => {
                setDetails((prevState) => ({
                  ...prevState,
                  account: e.target.value,
                }));
              }}
              value={details.account}
              required
            >
              <option value="">
                {balanceAvailable
                  ? "Select your account"
                  : "Insufficient funds in all accounts"}
              </option>
              {savingsAccounts.map(
                (acc, i) =>
                  acc.balance > details.amount && (
                    <option value={acc.account_number} key={i}>
                      {acc.account_number} | Balance: ₹{parseFloat(acc.balance).toLocaleString()}
                    </option>
                  )
              )}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="maturityDate">Maturity Date</label>
            <input
              type="text"
              value={details.maturityDate}
              readOnly
              placeholder="Will be calculated automatically"
              title="Maturity date is calculated based on tenure"
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isSubmitting || !balanceAvailable}
          >
            {isSubmitting ? "Processing..." : "Open Deposit"}
          </button>
        </form>
      </div>
    </div>
  );
};
